export const CREATE_TENANCY_CONTRACT = "CREATE_TENANCY_CONTRACT";
export const FETCH_TENANCY_CONTRACTS = "FETCH_TENANCY_CONTRACTS";
export const FETCH_TENANCY_CONTRACT = "FETCH_TENANCY_CONTRACT";
export const EDIT_TENANCY_CONTRACT = "EDIT_TENANCY_CONTRACT";
export const DELETE_TENANCY_CONTRACT = "DELETE_TENANCY_CONTRACT";
